import React from 'react'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { Footer } from '@/organisms/Footer'
import { SiteNav } from '@/organisms/SiteNav'
import { BaseLayout } from '../BaseLayout'

interface DefaultLayoutProps {
  children: React.ReactNode
  isDarkMode: boolean
}

export const HideTopNavigationLayout: React.FC<DefaultLayoutProps> = ({ children, isDarkMode }) => {
  return (
    <BaseLayout isDarkMode={isDarkMode}>
      <SiteNav hideNavigation={true} />
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
      <Footer />
    </BaseLayout>
  )
}
